/**
 * Theme Wishlist
 * ==============
 * Gestione wishlist lato client (localStorage).
 * Salva { variant_id, product_handle } per ogni prodotto aggiunto.
 *
 * INSTALLAZIONE:
 *  - Copia questo file in assets/
 *  - Includi nel layout/theme.liquid PRIMA di qualsiasi snippet che usa wishlist:
 *      <script src="{{ 'wishlist.js' | asset_url }}" defer></script>
 */

(() => {
  const STORAGE_KEY = 'theme_wishlist_variants';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    window.dispatchEvent(
      new CustomEvent('wishlist:updated', { detail: { wishlist: list } })
    );
  }

  function add({ variant_id, product_handle }) {
    const list = getWishlist();
    if (!list.some(i => i.variant_id === variant_id)) {
      list.push({ variant_id, product_handle });
      saveWishlist(list);
    }
  }

  function remove(variant_id) {
    saveWishlist(getWishlist().filter(i => i.variant_id !== variant_id));
  }

  function toggle({ variant_id, product_handle }) {
    has(variant_id)
      ? remove(variant_id)
      : add({ variant_id, product_handle });
  }

  function has(variant_id) {
    return getWishlist().some(i => i.variant_id === variant_id);
  }

  window.ThemeWishlist = { get: getWishlist, add, remove, toggle, has };
})();

// ─── Click handler: toggle wishlist su bottone [data-wishlist-toggle] ───────
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn || !window.ThemeWishlist) return;
  if (!btn.contains(e.target)) return;

  const card = btn.closest('product-card');
  if (card) card.dataset.wishlistLock = 'true';

  e.preventDefault();
  e.stopPropagation();

  if (btn.dataset.busy === 'true') return;
  btn.dataset.busy = 'true';

  const variant_id = Number(btn.dataset.variantId);
  const product_handle = btn.dataset.productHandle;
  const wasActive = btn.classList.contains('is-active');

  // UI ottimistica immediata
  btn.classList.toggle('is-active', !wasActive);
  btn.setAttribute('aria-pressed', String(!wasActive));

  if (wasActive) {
    ThemeWishlist.remove(variant_id);
  } else {
    ThemeWishlist.add({ variant_id, product_handle });
  }

  requestAnimationFrame(() => {
    if (card) delete card.dataset.wishlistLock;
    delete btn.dataset.busy;
  });
});

// Blocca pointerdown per evitare navigazione accidentale
document.addEventListener('pointerdown', (e) => {
  const btn = e.target.closest('[data-wishlist-toggle]');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
}, { capture: true });

// ─── Init: sincronizza stato bottoni al caricamento pagina ───────────────────
window.addEventListener('DOMContentLoaded', () => {
  if (!window.ThemeWishlist) return;

  document.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
    const variant_id = Number(btn.dataset.variantId);
    const isActive = ThemeWishlist.has(variant_id);
    btn.setAttribute('aria-pressed', String(isActive));
    btn.classList.toggle('is-active', isActive);
  });
});
